import Footer from '../components/Footer.jsx';

/**
 * Live tracking (page-livetrack.php).
 *
 * The original implementation scraped Gmail for Garmin LiveTrack links using
 * hardcoded Google OAuth secrets in client-side JS — an approach that is both
 * insecure and fragile. It has been intentionally stubbed out for the React
 * port. To re-enable it, implement a server-side integration in the Azure
 * Functions API (e.g. /api/livetrack) that holds the Google credentials in
 * application settings and returns the current LiveTrack URL.
 */
export default function LiveTrackPage() {
  return (
    <>
      <div
        style={{
          display: 'flex',
          height: '100vh',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          textAlign: 'center',
          padding: '1rem',
          gap: '1rem',
        }}
      >
        <h1>Live Tracking</h1>
        <p style={{ maxWidth: 600, color: 'var(--dark-grey)' }}>
          Live tracking is currently unavailable. Check back during a race to follow along in real
          time.
        </p>
      </div>
      <Footer />
    </>
  );
}
